import CONFIG from '../../CONFIG.js';

class Analytics {
	#inited = false;
	constructor() {
		console.log('Analytics constructor');
		this.gtm_id = CONFIG.gtm_id || null;

		if (this.gtm_id) this.init();
	}

	init() {
		if (!this.gtm_id) return;
		if (this.#inited) return;

		this.#inited = true;
		this.init_gtm();
	}
	
	init_gtm() {
		(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
		new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
		j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
		'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
		})(window,document,'script','dataLayer',this.gtm_id);
		console.log('GTM initialized',this.gtm_id);

		const noscript = document.createElement('noscript');
		const iframe = document.createElement('iframe');
		iframe.src = `https://www.googletagmanager.com/ns.html?id=${this.gtm_id}`;
		iframe.height = '0';
		iframe.width = '0';
		iframe.style.display = 'none';
		iframe.style.visibility = 'hidden';
		noscript.appendChild(iframe);
		if(document.body.firstChild){
			document.body.insertBefore(noscript, document.body.firstChild);
		} else {
			document.body.appendChild(noscript);
		}
	}

	track_era_toggle(era_index_or_name) {
		if (!this.#inited || !window.dataLayer) return console.log('track_era_toggle: GTM not initialized')	;

		const event_data = {
			event: 'custom_event',
			analytics_id: 'era_map',
			analytics_action: 'era toggle',
			analytics_detail: String(era_index_or_name ?? '')
		};

		window.dataLayer.push(event_data);
		console.log('track_era_toggle: event_data',event_data);
	}

	track_layer_toggle(layer_name, enabled) {
		if (!this.#inited || !window.dataLayer) return console.log('track_layer_toggle: GTM not initialized');

		const event_data = {
			event: 'custom_event',
			analytics_id: 'era_map',
			analytics_action: 'layer toggle',
			analytics_detail: `${layer_name}_${enabled ? 'on' : 'off'}`
		};

		window.dataLayer.push(event_data);
		console.log('track_layer_toggle: event_data',event_data);
	}

	track_car_click(era_index, car_type) {
		if (!this.#inited || !window.dataLayer) return console.log('track_car_click: GTM not initialized');

		const event_data = {
			event: 'custom_event',
			analytics_id: 'era_map',
			analytics_action: 'car click',
			analytics_detail: `${era_index}_${car_type || ''}`
		};

		window.dataLayer.push(event_data);
		console.log('track_car_click: event_data',event_data);
	}

	track_pin_click(uid) {
		if (!this.#inited || !window.dataLayer) return console.log('track_pin_click: GTM not initialized');

		const event_data = {
			event: 'custom_event',
			analytics_id: 'era_map',
			analytics_action: 'pin click',
			analytics_detail: uid || ''
		};

		window.dataLayer.push(event_data);
		console.log('track_pin_click: event_data',event_data);
	}

	track_menu_click_external(name) {
		if (!this.#inited || !window.dataLayer) return console.log('track_menu_click_external: GTM not initialized');

		const event_data = {
			event: 'custom_event',
			analytics_id: 'carousel',
			analytics_action: 'menu click',
			analytics_detail: name || ''
		};

		window.dataLayer.push(event_data);
		console.log('track_menu_click_external: event_data',event_data);
	}
}

const analytics = new Analytics();

export default analytics;
